export let Months = [
  { id: 1, name: "01" },
  { id: 2, name: "02" },
  { id: 3, name: "03" },
  { id: 4, name: "04" },
  { id: 5, name: "05" },
  { id: 6, name: "06" },
  { id: 7, name: "07" },
  { id: 8, name: "08" },
  { id: 9, name: "09" },
  { id: 10, name: "10" },
  { id: 11, name: "11" },
  { id: 12, name: "12" },
];

export let Years = [
  { id: 1, name: new Date().getFullYear() },
  { id: 2, name: new Date().getFullYear() + 1 },
  { id: 3, name: new Date().getFullYear() + 2 },
  { id: 4, name: new Date().getFullYear() + 3 },
  { id: 5, name: new Date().getFullYear() + 4 },
  { id: 6, name: new Date().getFullYear() + 5 },
  { id: 7, name: new Date().getFullYear() + 6 },
  { id: 8, name: new Date().getFullYear() + 7 },
  { id: 9, name: new Date().getFullYear() + 8 },
  { id: 10, name: new Date().getFullYear() + 9 },
  { id: 11, name: new Date().getFullYear() + 10 },
];
